import React from 'react';
import PropTypes from 'prop-types';

export default class ProgressCircle extends React.Component {
  static propTypes = {
    percentage: PropTypes.number,
    size: PropTypes.string
  };

  circleOptions = {
    xs: { diameter: 48, height: 50, centerY: 26, radius: 21, stroke: 6, fontSize: 13, margin: 3 },
    sm: { diameter: 96, radius: 40, stroke: 8, fontSize: 14, margin: 3 },
    md: { diameter: 140, radius: 60, stroke: 10, fontSize: 26, margin: 5 }
  }

  progressColor = () => {
    if (this.props.percentage < 66) {
      return "#FF8F00";
    } else if (this.props.percentage < 33) {
      return "#F57223";
    } else {
      return "#92D057";
    }
  }

  renderPercent() {
    const size = this.props.size || "md";
    const options = this.circleOptions[size];
    return (
      <text alignmentBaseline="mathematical" fontSize={options.fontSize} textAnchor="middle" x="50%" y="50%" >
        <tspan alignmentBaseline="mathematical" style={{ fontWeight: 'bold' }} textAnchor="middle" >
          { this.props.percentage }
        </tspan>
        %
      </text>
    );
  }

  render() {
    const size = this.props.size || "md";
    const options = this.circleOptions[size];
    const circumference = options.radius * 2 * Math.PI;
    const offset = circumference - this.props.percentage / 100 * circumference;
    const circleStyle = {
      strokeDasharray: circumference + ' ' + circumference,
      strokeDashoffset: offset
    };
    return (
      <svg
        className={`circle-progress mr-${options["margin"]}`}
        height={options.height || options.diameter}
        width={options.diameter}
      >
        <circle
          cx={options.centerX || (options.diameter / 2)}
          cy={options.centerY || (options.diameter / 2)}
          fill="transparent"
          r={options.radius}
          stroke="#EEEEEE"
          strokeWidth={options.stroke}
        />
        <circle
          className="circle"
          cx={options.centerX || (options.diameter / 2)}
          cy={options.centerY || (options.diameter / 2)}
          fill="transparent"
          r={options.radius}
          stroke={this.progressColor()}
          strokeLinecap="round"
          strokeWidth={options.stroke}
          style={circleStyle}
        />
        { this.renderPercent() }
      </svg>
    );
  }
}
